const getBooleanValue = (value: boolean | null | undefined): boolean => value ?? false;

export default getBooleanValue;
